import { render } from "./supply.vue?vue&type=template&id=25da74c0"
import script from "./supply.vue?vue&type=script&lang=js"
export * from "./supply.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"resources/js/vueComponents/admin/supply.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "25da74c0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('25da74c0', __exports__)) {
    api.reload('25da74c0', __exports__)
  }
  
  module.hot.accept("./supply.vue?vue&type=template&id=25da74c0", () => {
    api.rerender('25da74c0', render)
  })

}


export default __exports__